module.exports = __webpack_public_path__ + "static/media/water.8bcef956.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/water.jpg
// module id = 459
// module chunks = 0